import IFieldModel from "@mapmycustomers/shared/types/fieldModel/IFieldModel";
import IFiltersConfig from "@mapmycustomers/shared/types/fieldModel/IFilterConfig";
import { CombinedCondition } from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";

import { isCombinedCondition } from "@app/util/viewModel/assert";
import { getFieldByFilterName } from "@app/util/viewModel/getFieldByFilterName";

const checkIfConditionCanBeUsedInWebApp = (
  fieldModel: IFieldModel,
  combinedCondition: CombinedCondition
): boolean => {
  return combinedCondition.conditions.every((condition) => {
    if (isCombinedCondition(condition)) {
      return checkIfConditionCanBeUsedInWebApp(fieldModel, condition);
    }

    const { field } = getFieldByFilterName(condition.fieldFilterName, fieldModel);

    if (!field || !field.filter) {
      return false;
    }

    const filterInstanceToUse = (field.filter as IFiltersConfig).operators.find(
      ({ operator }) => operator === condition.operator
    )?.instance;

    return (
      !!filterInstanceToUse && (field.filter as IFiltersConfig).filterInstances[filterInstanceToUse]
    );
  });
};

export default checkIfConditionCanBeUsedInWebApp;
